import { render } from "./PaymentSuccessful.vue?vue&type=template&id=2f4aae98"
import script from "./PaymentSuccessful.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessful.vue?vue&type=script&lang=js"

import "./PaymentSuccessful.vue?vue&type=style&index=0&id=2f4aae98&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__